import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/styles.css'
import './assets/css/colors.css'

import axios from 'axios'
import { createHead } from '@vueuse/head'
import $ from 'jquery'
import i18n from './i18n'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import PrimeVue from 'primevue/config'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

import 'primeicons/primeicons.css'

window.$ = $
// axios.defaults.baseURL = "https://exhibit.z-demos.com/api";
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
//basic url
axios.defaults.baseURL = "https://dash.ruqm.me/api";
axios.defaults.withCredentials = true

const app = createApp(App)
const head = createHead()

app
  .use(router)
  .use(i18n)
  .use(head)
  .use(Toast)
  .use(PrimeVue) 
  .component('Dialog', Dialog)
  .component('Button', Button)
  .component('InputText', InputText)
  .mount('#app')
